import cloneDeep from 'lodash.clonedeep'
import { createTheme } from '@material-ui/core/styles'
import { globalThemeOverrideObject, lightTheme, themeType } from './themes'

export const fontSizeBodyKey = 'body2'
const busyCursorColorLightTheme = '#add8e6'

export const standardBodyFont = theme =>
  theme.typography[fontSizeBodyKey]

export const createUiTheme = strTheme =>
  createTheme(globalThemeOverrideObject(strTheme))

export const busyCursorColorOverride = innerTheme => {
  if (themeType(innerTheme) !== lightTheme) {
    const newObj = cloneDeep(innerTheme)
    newObj.palette.primary.main = busyCursorColorLightTheme
    return newObj
  }
  return innerTheme
}

export const informationDialogThemeOverride = innerTheme => {
  if (themeType(innerTheme) !== lightTheme) {
    return createTheme(lightTheme)
  } 
  return innerTheme
}

export const generalDialogThemeOverride = innerTheme =>
  informationDialogThemeOverride(innerTheme)

export const buttonOverride = () => {
  const override = {

  }
  return createTheme(override)
}

export * from './themes'

export * from './ThemeWrapper'
